export var BEGIN = Symbol('begin');
//# sourceMappingURL=constants.js.map